export const EXTERNAL_NAME = 'MeltwaterAppletHostV2';